import React, { FC } from 'react';
import styled from 'styled-components';

interface GreySummaryProps {
  open: boolean;
  children?: any;
}

export const GreySummary: FC<GreySummaryProps> = ({ open, children }) => {
  return (
    <>
      <StyledGreySummary>
        <div
          className={open ? 'executive-summary' : 'executive-summary closed'}
        >
          {children}
        </div>
      </StyledGreySummary>
    </>
  );
};

const StyledGreySummary = styled.div`
  .executive-summary {
    max-height: 10000px;
    overflow: hidden;
    transition: all 0.25s ease-in;
    z-index: 100;
  }

  .closed {
    max-height: 0;
    transition: max-height 0.25s ease-out;
    padding: 0;
  }
`;
